import { createSelector } from 'reselect';

import getBookingAccommodation from './getBookingAccommodation';
import getFirstTicketsForPax from './getFirstTicketsForPax';
// eslint-disable-next-line sort-imports
import {
  getBookingExtras,
  getBookingTransport,
  getTicketAllocations,
} from './index';

const getPassengerItems = createSelector(
  (state, bookingReference) => getBookingExtras(state, bookingReference),
  (state, bookingReference) => getBookingTransport(state, bookingReference),
  (state, bookingReference) => getBookingAccommodation(state, bookingReference),
  (state, bookingReference) => getFirstTicketsForPax(state, bookingReference),
  (state, bookingReference) => getTicketAllocations(state, bookingReference),
  (state, bookingReference, paxId, ticketId) => ({
    paxId: parseInt(paxId, 10),
    ticketId: ticketId ? parseInt(ticketId, 10) : null,
  }),
  (
    extras,
    transport,
    accommodation,
    firstTickets,
    ticketAllocations,
    { paxId, ticketId },
  ) => {
    const getEmptyPassengerItems = () => ({
      extras: [],
      transport: [],
      accommodation: [],
    });

    // If a specific ticketId is provided, check if it's the first ticket for this pax
    if (ticketId) {
      // Only show items if this is the first ticket for the pax
      const isFirstTicket = firstTickets[paxId] === ticketId;
      if (!isFirstTicket) {
        return getEmptyPassengerItems();
      }
    }

    // Otherwise, only return items if this paxId has a ticket and we're looking at the first one
    if (!firstTickets[paxId]) {
      return getEmptyPassengerItems();
    }

    return {
      extras: extras.filter(extra => parseInt(extra.pax_id, 10) === paxId),
      transport: transport.filter(item => parseInt(item.pax_id, 10) === paxId),
      // For accommodation, we need to check if the paxId is in the pax array
      accommodation: accommodation.filter(
        item =>
          item?.pax &&
          Array.isArray(item.pax) &&
          item.pax.some(paxIdValue => parseInt(paxIdValue, 10) === paxId),
      ),
    };
  },
);

export default getPassengerItems;
